<div class="pb-modal">
  <div class="pb-modal__header">
    <span class="pb-modal__title">
      <mat-icon class="pb-modal__cal-icon">calendar_today</mat-icon>
      {{ title }}
    </span>
    <button type="button" class="pb-modal__close" (click)="cancel()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="pb-modal__body">
    <label class="pb-modal__label">From Date &amp; Time <span class="pb-modal__utc">(UTC)</span></label>
    <button type="button"
            class="pb-modal__field"
            [class.pb-modal__field--active]="activeField === 'from'"
            (click)="focusField('from')">
      {{ display(from) }}
    </button>

    <label class="pb-modal__label">To Date &amp; Time <span class="pb-modal__utc">(UTC)</span></label>
    <button type="button"
            class="pb-modal__field"
            [class.pb-modal__field--active]="activeField === 'to'"
            (click)="focusField('to')">
      {{ display(to) }}
    </button>

    <div class="pb-picker">
      <div class="pb-picker__cal">
        <div class="pb-picker__cal-head">
          <button type="button" class="pb-picker__nav" (click)="prevMonth()" aria-label="Previous month">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <span class="pb-picker__month">{{ monthLabel }}</span>
          <button type="button" class="pb-picker__nav" (click)="nextMonth()" aria-label="Next month">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>

        <div class="pb-picker__grid">
          <span class="pb-picker__dow" *ngFor="let d of weekdays">{{ d }}</span>
          <ng-container *ngFor="let week of weeks">
            <ng-container *ngFor="let cell of week">
              <button type="button"
                      class="pb-picker__day"
                      [class.pb-picker__day--blank]="cell.day === 0"
                      [class.pb-picker__day--locked]="cell.locked && cell.day !== 0"
                      [class.pb-picker__day--today]="cell.today"
                      [class.pb-picker__day--selected]="cell.selected"
                      [disabled]="cell.locked || cell.day === 0"
                      (click)="selectDay(cell)">
                <ng-container *ngIf="cell.day !== 0">
                  <mat-icon class="pb-picker__lock" *ngIf="cell.locked">lock</mat-icon>
                  <span *ngIf="!cell.locked">{{ cell.day }}</span>
                </ng-container>
              </button>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <div class="pb-picker__time">
        <div class="pb-picker__time-head">Time</div>
        <div class="pb-picker__time-list">
          <button type="button"
                  class="pb-picker__time-item"
                  [class.pb-picker__time-item--active]="isActiveTime(t)"
                  *ngFor="let t of times"
                  (click)="selectTime(t)">
            {{ t }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="pb-modal__footer">
    <button type="button" class="pb-btn pb-btn--ghost" (click)="cancel()">Cancel</button>
    <button type="button" class="pb-btn pb-btn--primary" [disabled]="invalid" (click)="load()">
      Load Playback
    </button>
  </div>
</div>
